import React from 'react';
import { Link } from 'react-router-dom';
import PublicSiteHeader from '../../components/PublicSiteHeader/PublicSiteHeader';
import '../../components/PublicSiteHeader/publicSiteLayout.css';
import '../Legal/LegalPages.css';

const posts = [
  {
    slug: 'screen-tenants-kenya',
    title: 'How to Screen Tenants in Kenya: A Complete Guide for Landlords',
    excerpt:
      'Finding the right tenant is one of the biggest challenges landlords face in Kenya. Learn how proper screening reduces risk and protects your investment.',
    published: '27 June 2026',
  },
];

const Blog = () => (
  <div className="legal-page">
    <PublicSiteHeader />
    <main className="legal-page-main public-page-below-site-header">
      <div className="legal-page-container">
        <nav className="legal-breadcrumb" aria-label="Breadcrumb">
          <Link to="/">Home</Link>
          <span aria-hidden="true">/</span>
          <span>Blog</span>
        </nav>

        <header className="legal-page-header">
          <h1>Blog</h1>
          <p className="legal-page-updated">Tips and guides for landlords, hosts, and property managers in Kenya.</p>
        </header>

        <div className="legal-page-content">
          {posts.map((post) => (
            <article key={post.slug} style={{ marginBottom: posts.length > 1 ? '2rem' : 0 }}>
              <h2 style={{ marginTop: 0 }}>
                <Link to={`/blog/${post.slug}`}>{post.title}</Link>
              </h2>
              <p className="legal-page-updated" style={{ marginBottom: '0.75rem' }}>
                {post.published}
              </p>
              <p>{post.excerpt}</p>
              <Link to={`/blog/${post.slug}`}>Read more &rarr;</Link>
            </article>
          ))}
        </div>
      </div>
    </main>

    <footer className="legal-page-footer">
      <div className="legal-page-footer-inner">
        <p className="legal-page-copyright">&copy; 2026 TenantScore. All rights reserved.</p>
      </div>
    </footer>
  </div>
);

export default Blog;
